import { useScaleEvents } from '@components/ArtBoard/Canvas/hooks/events'
import { ProjectViewContent, useViewMenu } from '@components/ProjectViewContent'
import { DropdownMenu } from '@octopus-do/octopus-storybook'
import type React from 'react'

import { ZoomButtons } from './components'
import { useZoomMenu } from './hooks/useZoomMenu'

export const ZoomMenu: React.FC = () => {
  const { onViewClick } = useViewMenu()
  const { onZoomIn, onZoomOut } = useScaleEvents()
  const { btnText, showIndicator } = useZoomMenu()

  return (
    <DropdownMenu.Root
      align="center"
      onClick={onViewClick}
      content={ProjectViewContent}
    >
      <ZoomButtons
        btnText={btnText}
        showIndicator={showIndicator}
        onMinus={() => onZoomOut()}
        onPlus={() => onZoomIn()}
      />
    </DropdownMenu.Root>
  )
}
